import React, { useState, useEffect } from 'react';

import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import Autocomplete from '@material-ui/lab/Autocomplete';
import moment from 'moment';
import { WithApp } from 'contexts/appContext';
import { wsGetAll } from 'services/WService.js';
import { FormControl, InputLabel, MenuItem, Select } from '@material-ui/core';
import { wsFindBy } from 'services/WService';

export default WithApp(function ModalCuotaZonal(props) {
  const cuota = props.model;
  const [dataChanging, setDataChanging] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }

  // useEffect(() => {
  //   if (cuota.open) {
  //   }
  // }, [cuota.open]);

  return (
    <>
      <Modal
        title={`Nueva Cuota de Zonal para Verdum`}
        model={ cuota }
        setOpen={props.setOpen}
        showNotify={props.showNotify}
        reload={props.reload}
        arrDataResponse
        entity='sale/cuota-zonal'
      >
        <TextField
          label="Periodo"
          fullWidth
          type="month"
          name="Periodo"
          margin="normal"
          defaultValue={moment(cuota.valueSearch?.Periodo).format('YYYY-MM') || ''}
          InputLabelProps={{ shrink: true }}
          inputProps={{ readOnly: true }}
          required
        />
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Zonal</InputLabel>
          <Select
            required
            defaultValue={!!cuota ? cuota.zonal : ''}
            inputProps={{
              name: 'zonal',
            }}
          >
            <MenuItem value="NORTE">Norte</MenuItem>
            <MenuItem value="SUR">Sur</MenuItem>
          </Select>
        </FormControl>
        <FormControl fullWidth margin="normal" size="small">
          <InputLabel>Tipo</InputLabel>
          <Select
            required
            defaultValue={!!cuota ? cuota.tipo : ''}
            inputProps={{
              name: 'tipo',
            }}
          >
            <MenuItem value="O">Venta</MenuItem>
            <MenuItem value="I">Compra</MenuItem>
            <MenuItem value="C">Cobertura</MenuItem>
          </Select>
        </FormControl>
        <TextField
          label="Cuota"
          fullWidth
          type="number"
          name="cuota"
          margin="normal"
          defaultValue={!!cuota ? cuota.cuota : ''}
          onChange={(e) => handleChange('cuota', e.target.value)}
          required
        />
      </Modal>
    </>
  );
});

